/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Theme_SystemInputs */

const en_common_nav_theme_system = /** @type {(inputs: Common_Nav_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const zh_common_nav_theme_system = /** @type {(inputs: Common_Nav_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟随系统`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Common_Nav_Theme_SystemInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_theme_system = /** @type {((inputs?: Common_Nav_Theme_SystemInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Theme_SystemInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_theme_system(inputs)
	return zh_common_nav_theme_system(inputs)
});
export { common_nav_theme_system as "common.nav.theme_system" }